import React from 'react';
import { Box, Typography } from '@mui/material';

interface TimeListSectionProps {
  from: string;
  to: string;
  weekdays: string;
}

export const TimeListSection = ({
                                  from,
                                  to,
                                  weekdays,
                                }: TimeListSectionProps) => {
  return (
    <Box>
      <Box sx={{
        display: 'flex',
        marginTop: '2px',
      }}>
        <Typography sx={{
          color: '#1F1F1F',
          fontWeight: '700',
          fontSize: '12px',
        }}>
          {from}
        </Typography>
        <Typography sx={{
          margin: '0px 4px',
          color: '#9D9D9D',
          fontWeight: '400',
          fontSize: '12px',
        }}>
          to
        </Typography>
        <Typography sx={{
          color: '#1F1F1F',
          fontWeight: '700',
          fontSize: '12px',
        }}>
          {to}
        </Typography>
      </Box>
      <Box>
        <Typography sx={{
          fontSize: '12px',
          color: '#9D9D9D',
          fontWeight: '500',
        }}>
          {weekdays}
        </Typography>
      </Box>
    </Box>
  );
};
